import React, { Fragment, FunctionComponent } from 'react'
import { Link, NavLink, RouteComponentProps } from 'react-router-dom'
import styles from './Breadcrumbs.module.sass'
import clsx from 'clsx'
import { ROUTES } from '../../../http/routes'
import { EMPTY_PROJECT, Project, RelatedProject, relatedToString, ServerProject } from '../../../responses/projects'
//import { settingsRoutes } from '../../pages/settings/RefPage/refs-config'
import { useRouteMatch } from 'react-router'
import Skeleton from 'react-loading-skeleton'
import { useRootSelector } from '../../../utils/hooks'
import { urlWithParams } from '../../../http/utils'
import { objectSelector, projectSelector, taskSelector } from '../../../utils/selectors'
import ChevronRightIcon from 'files/chevron/right.svg'
import LinkIcon from 'files/bind.svg'
import useReactRouterBreadcrumbs, { BreadcrumbsRoute } from 'use-react-router-breadcrumbs'
import SUPIcon from 'files/sup.svg'
import FPIcon from 'files/fp.svg'

interface Props {
    className?: string,
}

const Breadcrumbs: React.FunctionComponent<Props> = props => {
    const breadcrumbs = useReactRouterBreadcrumbs(routes, { disableDefaults: true })

    if (breadcrumbs.length < 2) {
        return null
    }

    return (
        <div className={clsx(props.className, styles.breadcrumbs)}>
            {
                breadcrumbs.map((item, index) => {
                    const match = item.match as {url: string, path: string}
                    return <Fragment key={index}>
                        {
                            ((index === breadcrumbs.length - 1) || disabledRoutes.includes(item.match.url)) ?
                                <span className={clsx(styles.link, {
                                    [styles.active]: ![ROUTES.TASK, ROUTES.PROJECTS].includes(match.path) && (index === breadcrumbs.length - 1)
                                })}>
                                {item.breadcrumb}
                            </span> :
                                <NavLink
                                    exact
                                    className={styles.link}
                                    activeClassName={styles.active}
                                    to={item.match.url}
                                >
                                    {item.breadcrumb}
                                </NavLink>
                        }
                        <ChevronRightIcon/>
                    </Fragment>
                })
            }
        </div>
    )
}

const projectToRelated = (project: ServerProject | Project): RelatedProject => ({
    id: project.id,
    link: '',
    is_design: 1,
    code: project.code,
    name: project.name,
    direction: project.direction,
})

const ProjectBreadcrumb: React.FunctionComponent<RouteComponentProps<{ projectId: string }>> = props => {
    const project = useRootSelector(projectSelector(props.match.params.projectId))
    const isProjectDetail = useRouteMatch({
        path: ROUTES.PROJECT_DETAIL,
        exact: true,
    })

    return <div className={styles.projectBreadcrumb}>
        <span className={clsx({ [styles.current]: isProjectDetail })}>
            {
                project ? relatedToString(projectToRelated(project)) : <Skeleton width={150}/>
            }
        </span>
        {
            isProjectDetail && project?.related?.map(item => <Fragment
                key={item.id}
            >
                <LinkIcon className={styles.icon}/>
                {
                    item.is_design === 1 ?
                        <Link to={(new URL(item.link)).pathname} className={clsx(styles.bind,styles.nowrap)}>
                            <SUPIcon className={styles.breadcrumbsIcon} />
                           {relatedToString(item)}
                        </Link> :
                        <a href={item.link}  className={clsx(styles.bind,styles.nowrap)}>
                            <FPIcon className={styles.breadcrumbsIcon} />
                            {relatedToString(item)}
                        </a>
                }
            </Fragment>)
        }
    </div>
}

const TaskBreadcrumb: FunctionComponent<RouteComponentProps<{ taskId: string }>> = props => {
    const task = useRootSelector(taskSelector(props.match.params.taskId))
    const object = useRootSelector(objectSelector(task?.project_work_object_id))
    const project = useRootSelector(projectSelector(object?.project_id))
    return <>
        <Link to={urlWithParams({ projectId: project?.id })(ROUTES.PROJECT_DETAIL)}>
            {relatedToString(projectToRelated(project || EMPTY_PROJECT)) || <Skeleton width={100}/>}
        </Link>
        <ChevronRightIcon/>
        <Link to={urlWithParams({
            projectId: project?.id,
            objectId: task?.project_work_object_id
        })(ROUTES.OBJECT)}>
            {object?.work_object_type.work_object.name || <Skeleton width={120}/>}
        </Link>
        <ChevronRightIcon/>
        <span className={styles.active}>{task?.type.name || <Skeleton width={80}/>}</span>
    </>
}

const disabledRoutes = [ROUTES.SETTINGS]

const routes: BreadcrumbsRoute[] = [
    {
        breadcrumb: 'Проекты',
        path: ROUTES.PROJECTS,
    },
    {
        breadcrumb: TaskBreadcrumb,
        path: ROUTES.TASK,
    },
    {
        breadcrumb: 'Новый проект',
        path: ROUTES.PROJECTS_NEW,
    },
    {
        breadcrumb: 'Редактирование',
        path: ROUTES.PROJECTS_EDIT,
    },
    {
        breadcrumb: ProjectBreadcrumb,
        path: ROUTES.PROJECT_DETAIL,
    },
    {
        breadcrumb: 'Задачи',
        path: ROUTES.TASKS,
    },
    {
        breadcrumb: 'Статистика',
        path: ROUTES.STATISTICS,
    },
    /*{
        breadcrumb: 'Настройки',
        path: ROUTES.SETTINGS,
    },
    {
        breadcrumb: 'Роли',
        path: ROUTES.SETTINGS_ROLES,
    },
    {
        breadcrumb: 'Конфигурация',
        path: ROUTES.SETTINGS_CONFIG,
    }*/
]/*.concat(settingsRoutes.map(item => ({
    path: ROUTES.SETTINGS + '/' + item.key,
    breadcrumb: item.name,
})))*/

export default Breadcrumbs